module.exports = __webpack_public_path__ + "img/logoswap.5fca007d.png";